/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "axios";
import { toast } from 'react-toastify';

import { AI_BACKEND_API_2, API_TOKEN, API_URL } from "../../Config/secrets";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  queues: {},
  totalQueues: 0,
  selecteBatch: {},
  selectedFilters: {
    page: 1,
    filters: {},
  },
};

const slice = createSlice({
  name: "queues",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    resetBrand: () => initialState,

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.matchingLoading = false;
      state.matchResults = [];
    },

    // GET EVENTS
    getQueuesSuccess(state, action) {
      state.error = null;
      state.totalQueues = action.payload.total;
      (state.queues = {
        ...state.queues,
        [action.payload.page]: action.payload.data,
      });
      state.isLoading = false;
    },

    getBatchSuccess(state, action) {
      state.selecteBatch = action.payload
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetBrand, getqueuesSuccess } =
  slice.actions;

// ----------------------------------------------------------------------

const header = {
  Authorization: API_TOKEN,
};


export function getQueues(page = 1, take = 10) {
  return async (dispatch) => {
    try {
      let payload = { skip: page, take };
      // const isFilters = Object.keys(filters || {}).length > 0;

      // if (isFilters) {
      //   payload.filters = true;
      //   payload = { ...payload, ...filters };
      // }
      // if (query) payload.query = query;

      const response = await axios.post(`${API_URL}/brands/get-queues`, payload, {
        headers: header,
      });

      console.log('get-queues response', response.data)
      // if (response?.data?.statusCode === 200) {
      dispatch(
        slice.actions.getQueuesSuccess({
          page,
          total: response?.data?.data?.count || 0,
          data: response?.data?.data?.data || [],
        })
      );
      return response?.data?.data?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch wholesalers", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function getBatch(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${data?.admin ? AI_BACKEND_API_2 : "https://www.app.hyperscout.io/ai-backend"}/batch_status`, data, {
        headers: header,
      });

      dispatch(slice.actions.getBatchSuccess(response?.data?.data))
      return response?.data;
      // }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch batch data", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function refillBatch(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${data?.admin ? AI_BACKEND_API_2 : "https://www.app.hyperscout.io/ai-backend"}/refill_batch`, { batch_id: data?.batch_id }, {
        headers: header,
      });

      toast.success(response?.data?.message || "Batch refill triggered successfully", { autoClose: 3000 });
      return response?.data;
    } catch (error) {
      toast.error(error?.message || "Failed to refill batch", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}